import type { Dispatch, SetStateAction } from 'react';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';
import type { EmotionJSX } from 'node_modules/@emotion/react/dist/declarations/types/jsx-namespace';

import { Image } from 'Components/Image';
import { Tooltip } from 'Components/PortalTooltip';

import { infoIconTooltip } from 'assets/content/homeV2';
import { ReactComponent as InfoImgDark } from 'assets/images/homeRevamp/dark-info-icon.svg';
import { ReactComponent as InfoImgWhite } from 'assets/images/homeRevamp/white-info-icon.svg';

const StyledButton = styled.button`
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;

  background: transparent;

  /* inherit font & color from ancestor */
  color: inherit;
  font: inherit;

  line-height: normal;

  /* Corrects font smoothing for webkit */
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
`;

type InfoIconTooltipProps = {
  dataClick?: string;
  dataFrom?: string;
  setIsOpen?: Dispatch<SetStateAction<boolean>>;
  iconColor?: string;
  size?: number;
};

export const MobileInfoIconTooltip = ({
  dataClick,
  dataFrom,
  setIsOpen,
  iconColor = 'white',
  size = 16,
}: InfoIconTooltipProps) => {
  const icon = iconColor === 'white' ? infoIconTooltip.white : infoIconTooltip.dark;
  return (
    <StyledButton
      data-click={dataClick}
      data-from={dataFrom}
      onClick={() => setIsOpen && setIsOpen(true)}
      type="button"
    >
      <Image alt="" height={size} src={icon} width={size} />
    </StyledButton>
  );
};

const TooltipWrapper = styled.div`
  position: absolute;
  top: 0;
  right: -20px;
`;
type DesktopInfoTooltipProps = {
  tooltipContent: EmotionJSX.Element;
  iconColor?: string;
  size?: number;
  arrowShift?: number;
  topPlus?: number;
};

export const DesktopInfoTooltip = ({
  tooltipContent,
  iconColor = 'white',
  size = 24,
  arrowShift = 100,
  topPlus = 20,
}: DesktopInfoTooltipProps) => {
  return (
    <TooltipWrapper>
      <Tooltip
        arrowShift={arrowShift}
        content={tooltipContent}
        hasBeforePointer={false}
        maxWidth={238}
        openerComponent={iconColor === 'white' ? <InfoImgWhite /> : <InfoImgDark />}
        openerHeight={size}
        openerWidth={size}
        style={{
          padding: theme.spacing['5x'],
          fontSize: '12px',
          lineHeight: 'initial',
          backgroundColor: theme.colors.neutral[200],
        }}
        topPlus={topPlus}
      />
    </TooltipWrapper>
  );
};
